export const blockIconsAudioandvideoShuffle = (
	<span className='material-symbols-outlined'>shuffle</span>
);
